import { useCallback, useEffect, useMemo, useState } from "react";
import { apiMain } from "@/common/services";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { popupBus } from "@/common/buses";
import { PopupsEnum } from "@/components/popup-dispatcher/PopupDispatcher/popups";
import { setAgeDisclaimerAcceptedAt } from "@/common/utils/storage";
import { onCloseAgeDisclaimerPopup } from "@/components/popup-dispatcher/PopupDispatcher";

const DEFAULT_EXIT_URL = "https://www.google.com";

export const useAgeDisclaimerPopup = () => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const exitUrl = useMemo(() => redirectUrl ?? DEFAULT_EXIT_URL, [redirectUrl]);

  useEffect(() => {
    popupBus.emit("opened", { name: PopupsEnum.AgeDisclaimer });
  }, []);

  useEffect(() => {
    const fetchAgeGateUrl = async () => {
      setLoading(true);
      try {
        const { redirect_url } = await apiMain.getAgeGateSettings();
        setRedirectUrl(redirect_url || null);
      } catch (error) {
        console.error("Failed to fetch age gate URL", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgeGateUrl();
  }, []);

  const handleAgree = useCallback(() => {
    setAgeDisclaimerAcceptedAt(Date.now());
    onCloseAgeDisclaimerPopup();
  }, []);

  const handleExit = useCallback(() => {
    window.location.href = exitUrl;
  }, [exitUrl]);

  return {
    loading,
    isDesktop,
    handleAgree,
    handleExit,
  };
};
